import { store } from 'redux/store';
import { useEffect, useState } from 'react';
import { Document, Society } from 'types';
import { getDocument } from 'modules/documents/redux/documentActions';

type UseGetSocietySharesTitleDocumentProps = {
  society: Society;
};

export const useGetSocietySharesTitleDocument = ({
  society,
}: UseGetSocietySharesTitleDocumentProps) => {
  const [document, setDocument] = useState<Document>();
  const [documentWithCoOwners, setDocumentWithCoOwners] = useState<Document>();

  useEffect(() => {
    const fetchDocument = async () => {
      const documentId = society?.templates?.sharesTitle;
      const documentIdWithCoOwners =
        society?.templates?.sharesTitleWithCoOwners;

      if (documentId) {
        const document = await store.dispatch(getDocument(documentId));
        setDocument(document);
      }

      if (documentIdWithCoOwners) {
        const documentWithCoOwners = await store.dispatch(
          getDocument(documentIdWithCoOwners)
        );
        setDocumentWithCoOwners(documentWithCoOwners);
      }
    };

    fetchDocument();
  }, [society]);

  return {
    data: {
      document,
      documentWithCoOwners,
    },
  };
};
